import { useTranslation } from "react-i18next";
import InfoLayout from "./InfoLayout";
import "../../styles/InfoPage.css";

export default function ContactsPage() {
  const { t } = useTranslation("contacts");

  return (
    <InfoLayout title={t("title")}>

      <h2 className="infoH2">{t("visit_title")}</h2>

      <p className="infoP">
        {t("visit_text1")}
      </p>

      <p className="infoP">
        {t("visit_text2")}
      </p>

      <h2 className="infoH2">{t("contacts_title")}</h2>

      <p className="infoP">
        📍 {t("address")}: Київ, вул. Златоустівська, 22 <br />

        📞 {t("phone")}:
        <a href="tel:+380662337198"> +380 (66) 233 71 98</a>
      </p>

      <h2 className="infoH2">{t("online_title")}</h2>

      <p className="infoP">
        🌐 {t("site")}:{" "}
        <a
          href="https://www.konteyner.com.ua"
          target="_blank"
          rel="noopener noreferrer"
        >
          konteyner.com.ua
        </a>

        <br />

        📸 {t("instagram")}:{" "}
        <a
          href="https://www.instagram.com/kntynrbar"
          target="_blank"
          rel="noopener noreferrer"
        >
          @kntynrbar
        </a>

        <br />

        💬 {t("telegram")}:{" "}
        <a
          href="https://t.me/konteynerbar"
          target="_blank"
          rel="noopener noreferrer"
        >
          t.me/konteynerbar
        </a>
      </p>

    </InfoLayout>
  );
}